export default {
    serviceConfig: {
        create: 'Add Config',
        'create.success': 'Configuration created successfully',
        'update.success': 'Configuration updated successfully',
        'update.conflict':
            'This configuration was updated by someone else. Latest data has been loaded, please review and resubmit.',
        'delete.confirm': 'Delete this configuration?',
        'drawer.createTitle': 'Add Service Configuration',
        'drawer.editTitle': 'Edit Service Configuration',
        'detail.createTitle': 'Create Service Configuration',
        'detail.viewTitle': 'Configuration Details',
        'detail.editTitle': 'Edit Service Configuration',
        table: {
            key: 'Key',
            type: 'Type',
            module: 'Module',
            value: 'Value',
            updatedAt: 'Updated At',
            createdAt: 'Created At',
            actions: 'Actions',
            logs: 'Logs',
        },
        form: {
            key: 'Key',
            'key.required': 'Please enter a key',
            'key.placeholder': 'Enter configuration key',
            module: 'Module',
            'module.required': 'Please enter a module',
            'module.placeholder': 'Enter module name',
            type: 'Type',
            'type.required': 'Please select a type',
            value: 'Value',
            'value.required': 'Please enter configuration value',
            'value.invalidJson': 'Configuration value must be valid JSON',
        },
        type: {
            public: 'Public',
            private: 'Private',
        },
    },
};
